import { CheckCircleTwoTone } from '@ant-design/icons';
import { Card, Grid, Typography } from 'antd';
import cn from 'classnames';
import { FC } from 'react';
import NoImage from './no-image-placeholder.svg';
import styles from './select-boat-card.module.scss';

export type SelectBoatCardProps = {
  /**
   * boat name to be rendered as card title
   */
  title: string;
  /**
   * URL to image files path
   */
  imagePath?: string;
  /**
   * Show as selected card
   */
  isSelected?: boolean;
  /**
   * Callback on card click
   */
  onClickAction: () => void;
  /**
   * Optional className to make more customizations
   */
  className?: string;
  id?: string | null;
};

export const SelectBoatCard: FC<SelectBoatCardProps> = ({
  className,
  title,
  imagePath,
  isSelected,
  onClickAction,
  id,
}) => {
  const { sm } = Grid.useBreakpoint();
  const { Paragraph } = Typography;

  return (
    <div
      className={cn(styles.cardWrapper, { [styles.selectedCardWrapper]: isSelected }, className)}
      onClick={onClickAction}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}
      data-cy="select-boat-card"
      data-boat-id={id}
    >
      {isSelected && (
        <CheckCircleTwoTone twoToneColor={['var(--gray-1)', 'var(--green-6)']} className={styles.checkmark} />
      )}
      <Card
        className={styles.card}
        hoverable
        cover={
          <div style={{ height: sm ? 158 : 94 }} className={styles.cardCover}>
            {imagePath ? <img src={imagePath} alt="Placeholder" /> : <NoImage />}
          </div>
        }
      >
        <div className={styles.textContainer}>
          <Paragraph ellipsis={{ rows: 2 }} className={styles.textStyle}>
            {title}
          </Paragraph>
        </div>
      </Card>
    </div>
  );
};
